<div class="select-container"
     #container
     [class.large]="size === 'large'"
     (focus)="onFocus()"
     (keydown.arrowDown)="onMouseDown($event)"
     (mousedown)="onMouseDown($event)"
     tabindex="0"
     role="combobox"
>
    <select [formControl]="control"
            [class.default]="defaultSelected$ | async"
            cdkOverlayOrigin
            tabindex="-1"
            #selectElement
            #trigger="cdkOverlayOrigin"
    >
        @if (placeholder) {
            <option [value]="null"
                    disabled
            >
                {{ placeholder }}
            </option>
        }

        <ng-content select="option,optgroup"></ng-content>
    </select>

    <div class="arrow-container"
         [class.open]="selectControlRegistry.isOpen"
    >
        <span [appIcon]="'chevron-down'"
              class="chevron"
        ></span>

        <span class="intermediate"></span>
    </div>
</div>

@if (overlayPositions) {
    <ng-template
            cdkConnectedOverlay
            [cdkConnectedOverlayOrigin]="trigger"
            [cdkConnectedOverlayOpen]="selectControlRegistry.isOpen"
            [cdkConnectedOverlayHasBackdrop]="true"
            [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
            [cdkConnectedOverlayPositions]="overlayPositions"
            cdkConnectedOverlayBackdropClass="clear-backdrop"
            (backdropClick)="selectControlRegistry.close()"
    >
        <div class="options-container" [style.width]="container.clientWidth + 'px'">
            <app-select-options [configs$]="overlayConfigs$"
                                [control]="control"
                                [isLarge]="size === 'large'"
            ></app-select-options>
        </div>
    </ng-template>
} @else {
    <ng-template
            cdkConnectedOverlay
            [cdkConnectedOverlayOrigin]="trigger"
            [cdkConnectedOverlayOpen]="selectControlRegistry.isOpen"
            [cdkConnectedOverlayHasBackdrop]="true"
            [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
            cdkConnectedOverlayBackdropClass="clear-backdrop"
            (backdropClick)="selectControlRegistry.close()"
    >
        <div class="options-container" [style.width]="container.clientWidth + 'px'">
            <app-select-options [configs$]="overlayConfigs$"
                                [control]="control"
                                [isLarge]="size === 'large'"
            ></app-select-options>
        </div>
    </ng-template>
}
